import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../app/store/baseQuery";
import { qwMonarch } from "../../app/clients/qwMonarch";
import { formatNestedAddress } from "../../utils/address";

export const monarchBaseApi = createApi({
  reducerPath: "monarch",
  baseQuery: axiosBaseQuery(qwMonarch),
  endpoints: (builder) => ({
    searchLocations: builder.query({
      query: ({ q }) => ({
        url: `/v1/locations/search`,
        method: "GET",
        params: { q },
      }),
      transformResponse: (response) => {
        return response.map((location) => ({
          ...location,
          displayName: formatNestedAddress(location),
        }));
      },
    }),
  }),
});

export const { useSearchLocationsQuery } = monarchBaseApi;
